{
  "en": {
    "contributorRecovery": {
      "recoverButton": "Recover contributors",
      "submissionError": "Failed to submit contributor recovery request",
      "submissionSuccess": "Contributor recovery request submitted. Follow progress in the Tasks panel.",
      "noDocumentsSelected": "Please select at least one document"
    }
  },
  "fr": {
    "contributorRecovery": {
      "recoverButton": "Récupérer intervenant",
      "submissionError": "Échec de l'envoi de la requête de récupération des intervenants",
      "submissionSuccess": "Requête de récupération des intervenants envoyée. Suivez l'avancement dans le panneau Tâches.",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document"
    }
  },
  "nl": {
    "contributorRecovery": {
      "recoverButton": "Medewerkers ophalen",
      "submissionError": "Fout bij het indienen van het verzoek voor het ophalen van medewerkers",
      "submissionSuccess": "Verzoek voor het ophalen van medewerkers ingediend. Volg de voortgang in het takenpaneel.",
      "noDocumentsSelected": "Selecteer alstublieft minstens één document"
    }
  }
}
